export const REQUIRED_CONSENTS_MISSING_ERROR_CODE = 'consent.required_missing';
export const LEGAL_ACCEPTANCE_PENDING_ERROR_CODE = 'legal.acceptance_pending';
export const EMAIL_VERIFICATION_REQUIRED_ERROR_CODE = 'auth.email_verification_required';
export const DOMAIN_WORKSPACE_MISMATCH_ERROR_CODES: readonly string[] = [
  'workspace.account_not_in_domain_workspace',
  'workspace.not_served_on_this_domain',
];
